import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ContractsService } from '../../../services/contracts.service';
import { ErrorService } from '../../../shared/services/error.service';
import { B2bContractDriver } from '../../../models/Contract';

@Component({
  selector: 'app-b2b-contracts-driver-view',
  templateUrl: './b2b-contracts-driver-view.component.html',
  styleUrls: ['./b2b-contracts-driver-view.component.css']
})
export class B2bContractsDriverViewComponent implements OnInit {
  driver: any = null;
  isLoading = false;
  contractId: number | null = null;
  driverId: number | null = null;
  contractNumber: string = '';
  contractName: string = '';

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private contractsService: ContractsService,
    private errorService: ErrorService
  ) {}

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.contractId = +params['id'];
      this.driverId = +params['driverId'];
      if (this.contractId && this.driverId) {
        this.loadDriver();
        this.loadContractInfo();
      }
    });
  }

  loadContractInfo(): void {
    if (!this.contractId) return;

    this.contractsService.getB2bContractById(this.contractId).subscribe({
      next: (contract) => {
        this.contractNumber = contract.contractNumber || '';
        this.contractName = contract.contractName || '';
      },
      error: (err) => {
        this.errorService.handleHttpError(err);
      }
    });
  }

  loadDriver(): void {
    if (!this.contractId || !this.driverId) return;

    this.isLoading = true;

    this.contractsService.getB2bContractDriverById(this.contractId, this.driverId).subscribe({
      next: (driver) => {
        this.driver = driver;
        this.isLoading = false;
      },
      error: (err) => {
        this.errorService.handleHttpError(err);
        this.isLoading = false;
      }
    });
  }

  navigateBack(): void {
    if (this.contractId) {
      this.router.navigate(['/b2b/contracts', this.contractId, 'drivers']);
    } else {
      this.router.navigate(['/b2b/contracts']);
    }
  }

  navigateEdit(): void {
    if (!this.contractId || !this.driverId) return;
    this.router.navigate(['/b2b/contracts', this.contractId, 'drivers', this.driverId, 'edit']);
  }

  onDocumentsUpdated(driver: B2bContractDriver): void {
    this.driver = { ...this.driver, ...driver };
  }

  formatDate(dateString: string): string {
    if (!dateString) return 'N/A';
    try {
      return new Date(dateString).toLocaleDateString('pt-BR');
    } catch {
      return dateString;
    }
  }

  formatCpfCnpj(value: string): string {
    if (!value) return '-';
    const digits = String(value).replace(/\D/g, '');
    
    if (digits.length === 11) {
      // CPF
      return digits.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/, '$1.$2.$3-$4');
    } else if (digits.length === 14) {
      // CNPJ
      return digits.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, '$1.$2.$3/$4-$5');
    }
    return value;
  }

  formatPhone(value: string): string {
    if (!value) return '-';
    const digits = String(value).replace(/\D/g, '');
    
    if (digits.length === 10) {
      return digits.replace(/^(\d{2})(\d{4})(\d{4})$/, '($1) $2-$3');
    } else if (digits.length === 11) {
      return digits.replace(/^(\d{2})(\d{5})(\d{4})$/, '($1) $2-$3');
    }
    return value;
  }
}
